<template>
  <div
    v-if="showModal"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4 z-50"
    role="dialog"
    aria-labelledby="dialogTitle"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3
        id="dialogTitle"
        class="ml-6 mt-7 mb-5 text-zyxel-red-800"
      >
        {{ $t('messages.disable_2fa_modal.title') }}
      </h3>
      <p class="b1 ml-6 mr-6 text-zyxel-gray-800">
        {{ $t('messages.disable_2fa_modal.description') }}
      </p>
      <span class="b2 ml-6 mt-8 block text-left w-full text-zyxel-gray-800">{{ $t('messages.text_input.email')
      }}</span>
      <span class="b2 m-6 text-zyxel-gray-900">{{ user.email }}</span>
      <label
        for="password"
        class="b2 ml-6 mt-6 block text-left w-full text-zyxel-gray-800"
      >{{ $t('messages.text_input.password')
      }}</label>
      <div class="px-6 w-full mt-2">
        <PasswordInput
          id="password"
          v-model="password"
          :error="error"
          :aria-describedby="error ? 'password-error' : null"
        />
        <span
          v-if="error"
          id="password-error"
          class="error-message mt-1 b2 block text-left w-full mt-1"
        >{{
          $t(error) }}</span>
      </div>
      <div class="mt-8 hidden sm:flex justify-end">
        <button
          class="button-cancel min-w-[80px] mb-6 px-4 py-2 rounded ml-6"
          @click="cancel"
        >
          {{
            $t('messages.button.cancel') }}
        </button>
        <button
          class="button-warning mb-6 ml-2 mr-6 px-4 py-2 rounded"
          @click="turnoff"
        >
          {{
            $t('messages.button.turn_off')
          }}
        </button>
      </div>
      <div class="mt-8 flex-col sm:hidden p-6">
        <button
          class="button-warning w-full mb-4 rounded"
          @click="turnoff"
        >
          {{
            $t('messages.button.turn_off')
          }}
        </button>
        <button
          class="button-cancel w-full mb-6 rounded"
          @click="cancel"
        >
          {{
            $t('messages.button.cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { useAuthStore } from '@/stores/auth';
import PasswordInput from '@/components/PasswordInput.vue'

export default {
  name: 'Disable2FAModal',
  components: {
    PasswordInput
  },
  props: {
    showModal: Boolean,
    user: Object,
  },
  data() {
    return {
      password: "",
      error: null
    }
  },
  watch: {
    showModal() {
      this.password = "";
      this.error = null;
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    cancel() {
      this.$emit('close-modal');
    },
    async turnoff() {
      const auth = useAuthStore();

      this.error = null;
      const result = await auth.disable2FAByPassword(this.password);
      if (result) {
        this.$emit('close-modal');
        this.$emit('reset-otp-verified');
      } else {
        this.error = "messages.error_msg.password_incorrect";
      }
    },
    handleKeydown(event) {
      if (event.key === 'Escape' && this.showModal) {
        this.cancel(); // Use cancel method to close the modal
      }
    }
  }
}
</script>